var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.45898H2C1.72667 5.45898 1.5 5.23232 1.5 4.95898C1.5 4.68565 1.72667 4.45898 2 4.45898H14C14.2733 4.45898 14.5 4.68565 14.5 4.95898C14.5 5.23232 14.2733 5.45898 14 5.45898Z",
    fill: "#0F1142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.79297H4C3.72667 8.79297 3.5 8.5663 3.5 8.29297C3.5 8.01964 3.72667 7.79297 4 7.79297H12C12.2733 7.79297 12.5 8.01964 12.5 8.29297C12.5 8.5663 12.2733 8.79297 12 8.79297Z",
    fill: "#0F1142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 12.127H6.66797C6.39464 12.127 6.16797 11.9003 6.16797 11.627C6.16797 11.3536 6.39464 11.127 6.66797 11.127H9.33464C9.60797 11.127 9.83464 11.3536 9.83464 11.627C9.83464 11.9003 9.60797 12.127 9.33464 12.127Z",
    fill: "#0F1142"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.8a8db1ed47262cd8461936e0b7f6abf5.svg";
export { ForwardRef as ReactComponent };